var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.value},on:{"change":_vm.change}}),_vm._v(" "+_vm._s(_vm.label))])}
var staticRenderFns = []

export { render, staticRenderFns }